import { css } from 'styled-components';

export const BODY_FONT = css`
  font-family: 'Raleway', sans-serif;
`;

export const HEADER_FONT = css`
  font-family: 'Crimson Text', serif;
`;
